import React, { useEffect, useState } from "react";
import Container from "../../../../../layouts/containers/Container";
import baseUrl from "../../../../../api/baseUrl";
import { useNavigate, useParams } from "react-router-dom";
import "./examination.scss";
import PastTreatmentTr from "../../../manage/alltreatments/addtreatment/pasttreatment/PastTreatmentTr";
function Examination() {
  const [data, setdata] = useState([]);
  const { ID } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    baseUrl
      .get("/patient/findTreatmentByPid", {
        headers: {
          patientid: ID,
        },
      })
      .then((response) => {
        setdata(response.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [ID]);
  const handleCreatTreatment = () => {
    baseUrl
      .post("treatment/create-treatment", {
        patientId: ID,
      })
      .then((response) => {
        navigate(
          `/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onTrClick = (e: any) => {
    navigate(`/treatment-diagnose/add-treatment/diagnose/${e}`);
  };
  return (
    <Container className="examination-report past-treatment">
      <div className="header">
        Treatments List
        <button onClick={() => handleCreatTreatment()}>Add New</button>
      </div>
      <table>
        <thead>
        <tr>
            <th>Date </th>
            <th>Treatment</th>
           
            <th>note</th>
            <th>dentist</th>
            <th>status</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item: any, i: number) => <PastTreatmentTr key={i} item={item} />)}
        </tbody>
      </table>
    </Container>
  );
}

export default Examination;
